var _excluded = ["isOpen", "onRequestClose", "onBackClick", "title", "subtitle", "id", "headerIconButtonVariant", "primaryButtonProps", "secondaryButtonProps", "showDividers", "showOverlay", "stackCTAs", "analyticsName", "trackBoxImpression", "hasPadding"];

function cov_1r3isrjpns() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/Popover.tsx";
  var hash = "ee059089cad4283fd7ed296e5fc5741cf6bc07ff";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/Popover.tsx",
    statementMap: {
      "0": {
        start: {
          line: 61,
          column: 25
        },
        end: {
          line: 61,
          column: 28
        }
      },
      "1": {
        start: {
          line: 62,
          column: 27
        },
        end: {
          line: 66,
          column: 1
        }
      },
      "2": {
        start: {
          line: 67,
          column: 27
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "3": {
        start: {
          line: 73,
          column: 47
        },
        end: {
          line: 214,
          column: 1
        }
      },
      "4": {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 91,
          column: 32
        }
      },
      "5": {
        start: {
          line: 93,
          column: 25
        },
        end: {
          line: 93,
          column: 91
        }
      },
      "6": {
        start: {
          line: 94,
          column: 20
        },
        end: {
          line: 94,
          column: 63
        }
      },
      "7": {
        start: {
          line: 96,
          column: 37
        },
        end: {
          line: 96,
          column: 47
        }
      },
      "8": {
        start: {
          line: 98,
          column: 45
        },
        end: {
          line: 114,
          column: 3
        }
      },
      "9": {
        start: {
          line: 116,
          column: 45
        },
        end: {
          line: 127,
          column: 3
        }
      },
      "10": {
        start: {
          line: 129,
          column: 23
        },
        end: {
          line: 150,
          column: 3
        }
      },
      "11": {
        start: {
          line: 152,
          column: 2
        },
        end: {
          line: 213,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 73,
            column: 47
          },
          end: {
            line: 73,
            column: 48
          }
        },
        loc: {
          start: {
            line: 90,
            column: 6
          },
          end: {
            line: 214,
            column: 1
          }
        },
        line: 90
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 74,
            column: 11
          },
          end: {
            line: 74,
            column: 16
          }
        }],
        line: 74
      },
      "1": {
        loc: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 83,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 83,
            column: 17
          },
          end: {
            line: 83,
            column: 21
          }
        }],
        line: 83
      },
      "2": {
        loc: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 84,
            column: 16
          },
          end: {
            line: 84,
            column: 20
          }
        }],
        line: 84
      },
      "3": {
        loc: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 85,
            column: 14
          },
          end: {
            line: 85,
            column: 19
          }
        }],
        line: 85
      },
      "4": {
        loc: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 88,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 88,
            column: 15
          },
          end: {
            line: 88,
            column: 19
          }
        }],
        line: 88
      },
      "5": {
        loc: {
          start: {
            line: 93,
            column: 25
          },
          end: {
            line: 93,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 93,
            column: 33
          },
          end: {
            line: 93,
            column: 64
          }
        }, {
          start: {
            line: 93,
            column: 67
          },
          end: {
            line: 93,
            column: 91
          }
        }],
        line: 93
      },
      "6": {
        loc: {
          start: {
            line: 94,
            column: 20
          },
          end: {
            line: 94,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 94,
            column: 37
          },
          end: {
            line: 94,
            column: 41
          }
        }, {
          start: {
            line: 94,
            column: 44
          },
          end: {
            line: 94,
            column: 63
          }
        }],
        line: 94
      },
      "7": {
        loc: {
          start: {
            line: 126,
            column: 21
          },
          end: {
            line: 126,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 126,
            column: 35
          },
          end: {
            line: 126,
            column: 59
          }
        }, {
          start: {
            line: 126,
            column: 62
          },
          end: {
            line: 126,
            column: 75
          }
        }],
        line: 126
      },
      "8": {
        loc: {
          start: {
            line: 195,
            column: 16
          },
          end: {
            line: 195,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 195,
            column: 29
          },
          end: {
            line: 195,
            column: 30
          }
        }, {
          start: {
            line: 195,
            column: 33
          },
          end: {
            line: 195,
            column: 34
          }
        }],
        line: 195
      },
      "9": {
        loc: {
          start: {
            line: 199,
            column: 9
          },
          end: {
            line: 210,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 199,
            column: 10
          },
          end: {
            line: 199,
            column: 28
          }
        }, {
          start: {
            line: 199,
            column: 32
          },
          end: {
            line: 199,
            column: 52
          }
        }, {
          start: {
            line: 200,
            column: 10
          },
          end: {
            line: 209,
            column: 13
          }
        }],
        line: 199
      },
      "10": {
        loc: {
          start: {
            line: 201,
            column: 13
          },
          end: {
            line: 201,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 201,
            column: 13
          },
          end: {
            line: 201,
            column: 25
          }
        }, {
          start: {
            line: 201,
            column: 29
          },
          end: {
            line: 201,
            column: 40
          }
        }],
        line: 201
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ee059089cad4283fd7ed296e5fc5741cf6bc07ff"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1r3isrjpns = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1r3isrjpns();

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import ReactModal from 'react-modal';
import { Global, css } from '@emotion/react';
import { Box, Divider } from '../../core';
import { ThemedLite } from '../../theme/ODThemeLite';
import { getNavigationBarTitleId } from './NavigationBar';
import { useTheme } from '../../system/theme';
import { useDisabledBodyScroll, ModalHeader, ModalFooter } from './shared';
var CLOSE_TIMEOUT_MS = (cov_1r3isrjpns().s[0]++, 500);
var CONTENT_CLASS_NAME = (cov_1r3isrjpns().s[1]++, {
  base: 'BricksPopover__Content',
  afterOpen: 'BricksPopover__Content--after-open',
  beforeClose: 'BricksPopover__Content--before-close'
});
var OVERLAY_CLASS_NAME = (cov_1r3isrjpns().s[2]++, {
  base: 'BricksPopover__Overlay',
  afterOpen: 'BricksPopover__Overlay--after-open',
  beforeClose: 'BricksPopover__Overlay--before-close'
});
cov_1r3isrjpns().s[3]++;
export var Popover = function Popover(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? (cov_1r3isrjpns().b[0][0]++, false) : _ref$isOpen,
      onRequestClose = _ref.onRequestClose,
      onBackClick = _ref.onBackClick,
      title = _ref.title,
      subtitle = _ref.subtitle,
      id = _ref.id,
      headerIconButtonVariant = _ref.headerIconButtonVariant,
      primaryButtonProps = _ref.primaryButtonProps,
      secondaryButtonProps = _ref.secondaryButtonProps,
      _ref$showDividers = _ref.showDividers,
      showDividers = _ref$showDividers === void 0 ? (cov_1r3isrjpns().b[1][0]++, true) : _ref$showDividers,
      _ref$showOverlay = _ref.showOverlay,
      showOverlay = _ref$showOverlay === void 0 ? (cov_1r3isrjpns().b[2][0]++, true) : _ref$showOverlay,
      _ref$stackCTAs = _ref.stackCTAs,
      stackCTAs = _ref$stackCTAs === void 0 ? (cov_1r3isrjpns().b[3][0]++, false) : _ref$stackCTAs,
      analyticsName = _ref.analyticsName,
      trackBoxImpression = _ref.trackBoxImpression,
      _ref$hasPadding = _ref.hasPadding,
      hasPadding = _ref$hasPadding === void 0 ? (cov_1r3isrjpns().b[4][0]++, true) : _ref$hasPadding,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_1r3isrjpns().f[0]++;
  cov_1r3isrjpns().s[4]++;
  useDisabledBodyScroll(isOpen);
  var ariaLabelledBy = (cov_1r3isrjpns().s[5]++, title ? (cov_1r3isrjpns().b[5][0]++, getNavigationBarTitleId({
    id: id
  })) : (cov_1r3isrjpns().b[5][1]++, props['aria-labelledby']));
  var ariaLabel = (cov_1r3isrjpns().s[6]++, ariaLabelledBy ? (cov_1r3isrjpns().b[6][0]++, null) : (cov_1r3isrjpns().b[6][1]++, props['aria-label']));

  var _ref2 = (cov_1r3isrjpns().s[7]++, useTheme()),
      shadows = _ref2.shadows,
      radii = _ref2.radii,
      colors = _ref2.colors;

  var contentStyles = (cov_1r3isrjpns().s[8]++, {
    background: colors.neutrals0,
    WebkitOverflowScrolling: 'touch',
    outline: 'none',
    border: 'none',
    position: 'absolute',
    inset: 'auto',
    padding: 0,
    boxShadow: shadows.z2,
    borderRadius: radii.semiRounded,
    display: 'flex',
    flexDirection: 'column',
    // Popovers do not allow scrolling. Use full-screen modal if content overflows.
    overflow: 'hidden',
    maxHeight: 'calc(100vh - 48px)',
    maxWidth: 'calc(100vw - 48px)'
  });
  var overlayStyles = (cov_1r3isrjpns().s[9]++, {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999,
    backgroundColor: showOverlay ? (cov_1r3isrjpns().b[7][0]++, 'rgba(34, 34, 34, 0.60)') : (cov_1r3isrjpns().b[7][1]++, 'transparent')
  });
  var globalStyles = (cov_1r3isrjpns().s[10]++, /*#__PURE__*/css(".", OVERLAY_CLASS_NAME.base, "{opacity:0;transition:opacity ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", OVERLAY_CLASS_NAME.afterOpen, "{opacity:1;}.", OVERLAY_CLASS_NAME.beforeClose, "{opacity:0;}.", CONTENT_CLASS_NAME.base, "{transform:translateY(10%);transition:transform ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", CONTENT_CLASS_NAME.afterOpen, "{transform:translateY(0);}.", CONTENT_CLASS_NAME.beforeClose, "{transform:translateY(10%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:globalStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  cov_1r3isrjpns().s[11]++;
  return /*#__PURE__*/React.createElement(ReactModal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: showOverlay,
    className: CONTENT_CLASS_NAME,
    overlayClassName: OVERLAY_CLASS_NAME,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    style: {
      content: contentStyles,
      overlay: overlayStyles
    }
    /*
      Accessibility note: Aria-model indicates the presence of a modal element
      https://www.w3.org/TR/wai-aria-1.2/#aria-modal
    */
    ,
    "aria-modal": isOpen
    /*
      Accessibility note: use the contentLabel prop to provide a label for the modal content
      If the modal is already labeled with visible text, you should specify the element including the label with the aria-labelledby attribute.
      https://reactcommunity.org/react-modal/accessibility/#aria-attributes
      To set aria-labelledby, either (1) pass headerProps.title and let this component set aria-labelledby for you, or (2) pass ariaLabelledBy
      and set it to the id of your custom label
    */
    ,
    aria: {
      labelledby: ariaLabelledBy
    },
    contentLabel: ariaLabel
  }, /*#__PURE__*/React.createElement(Global, {
    styles: globalStyles
  }), /*#__PURE__*/React.createElement(ThemedLite, null, /*#__PURE__*/React.createElement(ModalHeader, {
    trackBoxImpression: trackBoxImpression,
    analyticsName: analyticsName,
    onBackClick: onBackClick,
    onRequestClose: onRequestClose,
    title: title,
    subtitle: subtitle,
    id: id,
    showDivider: showDividers,
    headerIconButtonVariant: headerIconButtonVariant
  }), /*#__PURE__*/React.createElement(Box, {
    p: hasPadding ? (cov_1r3isrjpns().b[8][0]++, 5) : (cov_1r3isrjpns().b[8][1]++, 0),
    maxWidth: "960px",
    maxHeight: "530px",
    overflow: "hidden"
  }, props.children), ((cov_1r3isrjpns().b[9][0]++, primaryButtonProps) || (cov_1r3isrjpns().b[9][1]++, secondaryButtonProps)) && (cov_1r3isrjpns().b[9][2]++, /*#__PURE__*/React.createElement(React.Fragment, null, (cov_1r3isrjpns().b[10][0]++, showDividers) && (cov_1r3isrjpns().b[10][1]++, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(ModalFooter, {
    stackCTAs: stackCTAs,
    primaryButtonProps: primaryButtonProps,
    secondaryButtonProps: secondaryButtonProps,
    analyticsName: analyticsName
  })))));
};
export default Popover;